import styles from './AppTable.module.scss';
import Placeholder from 'assets/img/table-placeholder.png';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { ReactNode } from 'react';

export const TablePlaceholder = (props: {
  customContent?: ReactNode;
  containerClassname?: string;
  testId?: string;
}) => {
  const i18n = useTranslation();

  return (
    <div
      data-test-id={props.testId}
      className={clsx(styles.container, props.containerClassname)}
    >
      <img className={styles.marginBottom52} src={Placeholder} />
      {props.customContent ? (
        props.customContent
      ) : (
        <>
          <div className={clsx(styles.title, styles.marginBottom12)}>
            {i18n.t('table_no_data_title')}
          </div>
          <div className={styles.text}>{i18n.t('table_no_data_message')}</div>
        </>
      )}
    </div>
  );
};
